var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50C38.8057 50 50 38.8057 50 25C50 11.1943 38.8057 0 25 0C11.1943 0 0 11.1943 0 25C0 38.8057 11.1934 50 25 50Z",
    fill: "#003399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5.55664L24.377 7.47266H22.3613L23.9863 8.65332L23.375 10.584L25 9.40332L26.623 10.584L26.0137 8.65332L27.6387 7.47266H25.625L25 5.55664Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 40.8062L25 38.8901L24.377 40.8062H22.3613L23.9863 41.9868L23.375 43.9175L25 42.7368L26.623 43.9175L26.0117 41.9868L27.6367 40.8062H25.625Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33496 26.0757L9.95996 27.2476L9.34863 25.3169L10.9736 24.1362H8.95996L8.33496 22.2202L7.70996 24.1362H5.69629L7.32129 25.3169L6.70996 27.2476L8.33496 26.0757Z",
    fill: "#FFCC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 7.79297L16.041 9.70996H14.0293L15.6543 10.9043L15.043 12.8203L16.666 11.623L18.291 12.8174L17.6797 10.9014L19.3057 9.70703H17.2959L16.666 7.79297Z",
    fill: "#FFCC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5742 13.8901L9.94922 15.8062H7.93555L9.56055 16.9868L8.93555 18.9175L10.5742 17.7368L12.1992 18.9175L11.5742 16.9868L13.2129 15.8062H11.1982L10.5742 13.8901Z",
    fill: "#FFCC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1982 32.4727L10.5732 30.5566L9.94824 32.4727H7.93555L9.56055 33.6533L8.93555 35.584L10.5742 34.4033L12.1992 35.584L11.5742 33.6533L13.2129 32.4727H11.1982Z",
    fill: "#FFCC00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2949 38.5747L16.666 36.6538L16.0449 38.5747H14.0293L15.6543 39.769L15.0449 41.6802L16.666 40.4858L18.291 41.6802L17.6797 39.7642L19.3086 38.5747H17.2949Z",
    fill: "#FFCC00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3096 24.1392H42.2959L41.6709 22.2231L41.0459 24.1392H39.0293L40.6543 25.3198L40.0459 27.2466L41.6709 26.0747L43.2959 27.2466L42.6846 25.3159L44.3096 24.1392Z",
    fill: "#FFCC00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.335 7.79297L32.71 9.70996H30.6963L32.3213 10.9043L31.71 12.8203L33.335 11.623L34.96 12.8174L34.3486 10.9014L35.9736 9.70703H33.96L33.335 7.79297Z",
    fill: "#FFCC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4316 16.9868L37.8066 18.9175L39.4316 17.7368L41.0703 18.9175L40.4453 16.9868L42.0703 15.8062H40.0566L39.4316 13.8901L38.8066 15.8062H36.793L38.4316 16.9868Z",
    fill: "#FFCC00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0566 32.4727L39.4316 30.5566L38.8066 32.4727H36.793L38.4316 33.6533L37.8066 35.584L39.4316 34.4033L41.0703 35.584L40.4453 33.6533L42.0713 32.4727H40.0566Z",
    fill: "#FFCC00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.96 38.5747L33.335 36.6587L32.71 38.5747H30.6963L32.3213 39.769L31.71 41.6851L33.335 40.4907L34.96 41.6851L34.3486 39.769L35.9736 38.5747H33.96Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.0bfbce9f9e906a5f7e5aede09e41af44.svg";
export { ForwardRef as ReactComponent };